"use strict";

module.exports = function () {
  if (typeof localStorage === 'undefined') return {};
  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/computed/storage.js
// module id = 867
// module chunks = 0